export default __webpack_public_path__ + "static/media/premium-china-town-district.01bffa56.png";